import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { useState } from 'react'

import { Question } from './question'
import {
  MAX_VISIBLE_QUESTIONS,
  QuestionsList,
  ShowMoreToggle,
  OverflowQuestions
} from './questions_overflow'
import { WidgetContainer } from '../widget_container'

export const QuestionsSection = ({ label, questions, maxVisible }) => {
  if (!questions || questions.length === 0) return null

  const visible = maxVisible != null ? questions.slice(0, maxVisible) : questions

  return (
    <>
      <BodyText weight="bold" color={colorTextSecondary}>{label}</BodyText>
      {visible.map((question) => (
        <Question key={question.name} {...question} />
      ))}
    </>
  )
}

const SoloEventQuestions = ({ event }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const routingQuestions = event.invitee?.formBuilderSubmission?.questions
  const attendeeQuestions = event.invitee?.eventFields

  const hasRouting = routingQuestions?.length > 0
  const hasAttendee = attendeeQuestions?.length > 0

  if (!hasRouting && !hasAttendee) return null

  const routingOverflow = (routingQuestions?.length ?? 0) > MAX_VISIBLE_QUESTIONS
  const attendeeOverflow = (attendeeQuestions?.length ?? 0) > MAX_VISIBLE_QUESTIONS
  const hasOverflow = routingOverflow || attendeeOverflow

  return (
    <WidgetContainer title={I18n.t('publisher.meetings.tabs.questions')} showBorder={false} noPadding sectionWithBottomBorder>
      <QuestionsList>
        {hasRouting ? (
          <>
            <QuestionsSection
              label={I18n.t('publisher.meeting_intelligence.details.questions.routing_label')}
              questions={routingQuestions}
              maxVisible={MAX_VISIBLE_QUESTIONS}
            />
            <OverflowQuestions questions={routingQuestions} isExpanded={isExpanded} />
            <QuestionsSection
              label={I18n.t('publisher.meeting_intelligence.details.questions.attendee_label')}
              questions={attendeeQuestions}
              maxVisible={MAX_VISIBLE_QUESTIONS}
            />
          </>
        ) : (
          attendeeQuestions.slice(0, MAX_VISIBLE_QUESTIONS).map((question) => (
            <Question key={question.name} {...question} />
          ))
        )}
        <OverflowQuestions questions={attendeeQuestions} isExpanded={isExpanded} />
        {hasOverflow && (
          <ShowMoreToggle isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
        )}
      </QuestionsList>
    </WidgetContainer>
  )
}

export const QuestionsWidget = ({ event }) => {
  const isGroupEvent = event.eventType?.kind === 'group'

  if (isGroupEvent) return null

  return <SoloEventQuestions event={event} />
}
